// extracted by mini-css-extract-plugin
module.exports = {"margin":"FooterBanner_margin__WyAOD"};